import React, { useState } from 'react';
import './CategoryTextStyleSection.css';
import UniversalSectionContainer from './UniversalSectionContainer';

function CategoryTextStyleSection({ editData, handleInputChange }) {
    
    return (
        <UniversalSectionContainer 
            icon={<i className="fa fa-tag"></i>}
            title="Category Text Style" 
            count={5}
            gradient="purple"
            defaultExpanded={false}
        >
            <div className="category-text-properties-grid">
                
                {/* Color Controls - Revolutionary Layout Property Style */}
                <div className="category-text-property color-property" style={{ gridColumn: '1 / -1' }}>
                    <div className="category-property-header">
                        <div className="category-property-label-row">
                            <span className="category-property-icon">🎨</span>
                            <label className="category-property-label">Colors</label>
                        </div>
                    </div>
                    <div className="category-color-picker-row">
                        <div className="category-color-picker-item">
                            <span className="category-color-label">Background</span>
                            <input
                                type="color"
                                name="categoryTextBackgroundColor"
                                value={editData.categoryTextBackgroundColor || '#ffffff'}
                                onChange={handleInputChange}
                                className="category-color-input"
                            />
                        </div>
                        <div className="category-color-picker-item">
                            <span className="category-color-label">Border</span>
                            <input
                                type="color"
                                name="categoryTextBorderColor"
                                value={editData.categoryTextBorderColor || '#cccccc'}
                                onChange={handleInputChange}
                                className="category-color-input"
                            />
                        </div>
                    </div>
                </div>

                {/* Dimension Controls - Revolutionary Layout Property Style */}
                <div className="category-text-property">
                    <div className="category-property-header">
                        <div className="category-property-label-row">
                            <span className="category-property-icon">📐</span>
                            <label className="category-property-label">Width</label>
                        </div>
                    </div>
                    <div className="category-property-slider-container">
                        <input
                            type="range"
                            name="categoryTextPaddingWidth"
                            min="0"
                            max="50"
                            step="2"
                            value={editData.categoryTextPaddingWidth || 0}
                            onChange={handleInputChange}
                            className="category-property-slider"
                        />
                        <div className="category-property-value">{editData.categoryTextPaddingWidth || 0}px</div>
                    </div>
                </div>

                <div className="category-text-property">
                    <div className="category-property-header">
                        <div className="category-property-label-row">
                            <span className="category-property-icon">📏</span>
                            <label className="category-property-label">Height</label>
                        </div>
                    </div>
                    <div className="category-property-slider-container">
                        <input
                            type="range"
                            name="categoryTextPaddingHeight"
                            min="0"
                            max="30"
                            step="2"
                            value={editData.categoryTextPaddingHeight || 0}
                            onChange={handleInputChange}
                            className="category-property-slider"
                        />
                        <div className="category-property-value">{editData.categoryTextPaddingHeight || 0}px</div>
                    </div>
                </div>

                <div className="category-text-property">
                    <div className="category-property-header">
                        <div className="category-property-label-row">
                            <span className="category-property-icon">🔲</span>
                            <label className="category-property-label">Border Radius</label>
                        </div>
                    </div>
                    <div className="category-property-slider-container">
                        <input
                            type="range"
                            name="categoryTextBorderRadius"
                            min="0"
                            max="20"
                            step="1"
                            value={editData.categoryTextBorderRadius || 0}
                            onChange={handleInputChange}
                            className="category-property-slider"
                        />
                        <div className="category-property-value">{editData.categoryTextBorderRadius || 0}px</div>
                    </div>
                </div>

                <div className="category-text-property">
                    <div className="category-property-header">
                        <div className="category-property-label-row">
                            <span className="category-property-icon">🔳</span>
                            <label className="category-property-label">Border Width</label>
                        </div>
                    </div>
                    <div className="category-property-slider-container">
                        <input
                            type="range"
                            name="categoryTextBorderWidth"
                            min="0"
                            max="5"
                            step="1"
                            value={editData.categoryTextBorderWidth || 0}
                            onChange={handleInputChange}
                            className="category-property-slider"
                        />
                        <div className="category-property-value">{editData.categoryTextBorderWidth || 0}px</div>
                    </div>
                </div>
                
            </div>
        </UniversalSectionContainer>
    );
}

export default CategoryTextStyleSection;
